import {UntypedFormControl, UntypedFormGroup, UntypedFormArray} from '@angular/forms';
import {Parametro} from '../intranet/model/parametro';

export const functionUtil = {
  fnKeyDownPassword(e) {
    // const key = window.event ? e.which : e.keyCode;
    if (!e.key.match(/^[A-Za-z0-9ñÑ\-._*@!%&$#+=?]+$/)) {
      e.preventDefault();
    }
  },
  fnKeyDownAlphaNumeric_latin(e) {
    // const key = window.event ? e.which : e.keyCode;
    if (!e.key.match(/^[A-Za-z0-9 ñÑáéíóúÁÉÍÓÚ]+$/)) {
      e.preventDefault();
    }
  },
  fnKeyDownAlphaNumeric(e) {
    // const key = window.event ? e.which : e.keyCode;
    if (!e.key.match(/^[A-Za-z0-9]+$/)) {
      e.preventDefault();
    }
  },
  fnKeyDownNumeric(e) {
    const key = e.which || e.keyCode;
    if (key < 48 || key > 57 || !e.key.match(/^[0-9]+$/)) {
      e.preventDefault();
    }
  },
  // onkeyup="numberMobile(event);"
  fnKeyDownPasswordMobile(e) {
    e.target.value = e.target.value.replace(/[^[A-Za-z0-9ñÑ]]/g, '');
    return false;
  },
  fnNumericMobile(e) {
    e.target.value = e.target.value.replace(/[^\d]/g, '');
    return false;
  },

  fnAlphaNumericMobile(e) {
    e.target.value = e.target.value.replace(/[^A-Za-z0-9 ñÑáéíóúÁÉÍÓÚ]+/g, '');
    return false;
  },
  fnInputMaxLength(e) {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
      e.preventDefault();
    }
  },
  detectMobile() {
    return !!(navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/Opera Mini/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/IEMobile/i)
      || navigator.userAgent.match(/WPDesktop/i)
      || navigator.userAgent.match(/Windows Phone/i)
      || (window.innerWidth <= 800 && window.innerHeight <= 600));
  }
};

export const SURA_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

// tslint:disable-next-line:class-name
export class functionHelper {
  public static obtenerControlByFormGroup(formGroup: UntypedFormGroup, controlName: string) {
    // let _a = controlName.split('.');
    /**
     let control = formGroup.controls[controlName];
     if(control instanceof FormControl)
     return control;
     if(control instanceof formGroup)
     return this.obtenerControlByFormGroup(control)
     */
  }

  public static extraerErrorArray(formArray: UntypedFormArray, index: number, controlName: string) {
    const control = formArray.controls[index];
    if (control instanceof UntypedFormGroup) {
      return this.extraerErrorGroup(control, controlName);
    } else if (control instanceof UntypedFormControl) {
      return this.extraerError(control);
    }
  }

  public static extraerErrorGroup(formGroup: UntypedFormGroup, controlName: string) {
    return this.extraerError(formGroup.controls[controlName] as UntypedFormControl);
  }

  public static extraerError(control: UntypedFormControl) {
    return control.hasError('required') ? 'Campo obligatorio' :
      control.hasError('minlength') ? 'Mínimo ' + control.errors.minlength.requiredLength + ' caracteres' :
        control.hasError('maxlength') ? 'Máximo ' + control.errors.maxlength.requiredLength + ' caracteres' :
          control.hasError('email') ? 'Estructura del correo incorrecto' :
            control.hasError('pattern') ? 'Estructura o formato incorrecto' :
              control.hasError('min') ? 'Valor mínimo ' + control.errors.min.min :
                control.hasError('max') ? 'Valor máximo ' + control.errors.max.max :
                  control.hasError('requiredNumero') ? 'Al menos un número' :
                    control.hasError('requiredMinuscula') ? 'Al menos una letra minúscula' :
                      control.hasError('requiredMayuscula') ? 'Al menos una letra mayúscula' :
                        control.hasError('requiredCaracterEspecial') ? 'Al menos un caracter especial' :
                          control.hasError('different') ? 'Debe ser diferente al valor ' + control.errors.cadenaDiff :
                            null;
  }

  public static getDescripcionParametro(valor: string, parametros: Parametro[]) {
    let descripcion = '';
    parametros.forEach(parametro => {
      if (parametro.codigo != null && parametro.codigo.toUpperCase() === valor.toUpperCase()) {
        descripcion = parametro.descripcion;
      }
    });
    return descripcion;
  }
}
